import { UploadImagesState } from "../contexts/uploadFiles";
import { AddImagesRequest } from "../store/offerSlice/types";


export const getAddImagesData = (files: UploadImagesState) : AddImagesRequest => {
    return Object.entries(files).reduce((acc, [questionId, fileItem]) => {
        acc[questionId] = fileItem.file;
        return acc
    }, {} as AddImagesRequest)
}